
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from '../core/core'
import { SE_CORE_MODULE_BUNDLE } from '../core/core.module'
import { SE_ICON_MODULE_BUNDLE } from '../icon/icon.module'

import { SeAlertComponent } from './alert.component'
import { SeIconModule } from '../icon/icon.module'

@NgModule({
  declarations: [
    SeAlertComponent,
  ],
  imports: [
	CommonModule, 
    SeIconModule
  ],
  exports: [
    SeAlertComponent
  ]
})
export class SeAlertModule {}

export const SE_ALERT_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.alert`

